/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_Last_Name_LabelInputs */

const fr_membership_friend_guest_last_name_label = /** @type {(inputs: Membership_Friend_Guest_Last_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom (facultatif)`)
};

/**

* @param {Membership_Friend_Guest_Last_Name_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_last_name_label = /** @type {((inputs?: Membership_Friend_Guest_Last_Name_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_Last_Name_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_last_name_label(inputs)
});